import { useState, useEffect, useRef } from 'react';

const useScrollAnimation = (threshold = 0.1) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const element = ref.current; 
    let observer; 

    if (element) {
      observer = new IntersectionObserver( 
        ([entry]) => { 
          if (entry.isIntersecting) {
            setIsVisible(true);
            // observer.unobserve(entry.target); // 한 번만 애니메이션을 실행하려면 이 줄의 주석을 해제하세요.
          }
        }, 
        { threshold }
      );
      observer.observe(element);
    }

    return () => { 
      if (element && observer) {
        observer.unobserve(element);
      }
    };
  }, [ref, threshold]); 

  return [ref, isVisible];
};

export default useScrollAnimation;
